module.exports = __webpack_public_path__ + "static/smart_1-f7fd5ff8095dfeab19a1e8c2e5dd4ecd.png";